import { NavLink, Outlet, Link } from "react-router-dom";
import { Camera, BookOpen, MapPin, Trophy, User } from "lucide-react";
import { ShareButton } from "./ShareButton";
import { Logo } from "./Logo";
import { useAuth } from "../context/AuthContext";

const TABS = [
  { to: "/scan", label: "Scan", icon: Camera },
  { to: "/log", label: "Log", icon: BookOpen },
  { to: "/spots", label: "Spots", icon: MapPin },
  { to: "/leaderboard", label: "Ranks", icon: Trophy },
  { to: "/profile", label: "Profile", icon: User },
];

export default function AppShell() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen pb-24">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#0A0A0C]/90 border-b-2 border-[#FF4D00]">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/scan" data-testid="header-logo"><Logo size={30} /></Link>
          <div className="flex items-center gap-2">
            {user?.region && (
              <Link to="/profile" data-testid="header-region-badge"
                className="text-xs font-bold border-2 border-[#FF4D00] text-[#FF4D00] px-2 py-1">{user.region}</Link>
            )}
            <ShareButton compact />
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}

function BottomNav() {
  return (
    <nav data-testid="bottom-tab-bar"
      className="fixed bottom-0 inset-x-0 z-50 bg-[#0A0A0C] border-t-2 border-[#FF4D00] pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-3xl mx-auto grid grid-cols-5 h-16">
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} data-testid={`tab-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] font-bold uppercase tracking-wider transition-colors ${
                isActive ? "bg-[#FF4D00] text-black" : "text-zinc-400 hover:text-white"}`}>
            <Icon size={20} strokeWidth={2.5} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
